import { t } from "@/lib/i18n";

/** „auch bei …“: andere Artikel mit derselben EAN, anklickbar */
export function SameGtin({ items, onOpen }: { items: { id: string; sku: string; name: string }[]; onOpen?: (id: string) => void }) {
  return (
    <div className="mt-1 flex flex-wrap items-center gap-1 text-[11.5px] text-fg-muted max-w-[260px]">
      <span>{t("auch bei")}</span>
      {items.map((x) => (
        <button key={x.id} type="button" title={x.name} onClick={(e) => { e.stopPropagation(); onOpen?.(x.id); }} className="font-mono rounded-md border border-warning/40 bg-warning-soft px-1.5 h-5 text-[11px] text-fg hover:border-warning">
          {x.sku}
        </button>
      ))}
    </div>
  );
}
